export default "__VITE_ASSET__C8grR7Hw__"